import $ from 'jquery'

function toggleAcknowledge() {
  const footerAcknowledgeRights = document.querySelectorAll('.footer-acknowledge-right h5')

  if ( !footerAcknowledgeRights || window.innerWidth > 1024 ) {
    return;
  }

  [...footerAcknowledgeRights].forEach( (footerAcknowledgeRight) => {
    footerAcknowledgeRight.addEventListener( 'click', (e) => {
      $( e.target ).next().slideToggle()
    })
  })
}

const init = () => {
  toggleAcknowledge()
}

export default {
  init,
}
